
<div class="card-image-upload">
  <image-upload
    v-model="card.image"
    name="front-image"
    :label="allowBackImage ? 'Front image' : 'Card image'"
    :icon="allowBackImage ? 'camera_front' : 'upload_file'"
    width="150"
    height="250"
    @result="$emit('result', $event)"
  />

  <image-upload
    v-if="allowBackImage"
    v-model="card.imageBack"
    name="back-image"
    label="Back image"
    icon="camera_rear"
    width="150"
    height="250"
    @result="$emit('result', $event)"
  />
</div>
